export default "https://cdn-static.gokick.com/assets/f85860d356d81c773b535a0002382fa42e6b6edf/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";